import React from 'react';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { create } from 'jss';
import rtl from 'jss-rtl';
import MomentUtils from '@date-io/moment';
import { SnackbarProvider } from 'notistack';
import { jssPreset, StylesProvider, ThemeProvider } from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import GlobalStyles from 'src/devias/components/GlobalStyles';
import ScrollReset from 'src/devias/components/ScrollReset';
//import CookiesNotification from 'src/devias/components/CookiesNotification';
import GoogleAnalytics from 'src/devias/components/GoogleAnalytics';
//import SettingsNotification from 'src/devias/components/SettingsNotification';
import { AuthProvider } from 'src/devias/contexts/JWTAuthContext';
import { AuthProvider as AppAuthProvider } from 'src/contexts/JWTAuthContext';
import useSettings from 'src/devias/hooks/useSettings';
import { createTheme } from 'src/theme';
import routes, { renderRoutes } from 'src/devias/routes';
import appRoutes, { renderAppRoutes } from './routes';

const jss = create({ plugins: [...jssPreset().plugins, rtl()] });
const history = createBrowserHistory();

const App = () => {
  const { settings } = useSettings();

  const theme = createTheme({
    direction: settings.direction,
    responsiveFontSizes: settings.responsiveFontSizes,
    theme: settings.theme
  });

  return (
    <ThemeProvider theme={theme}>
      <StylesProvider jss={jss}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <SnackbarProvider dense maxSnack={3}>
            <Router history={history}>
              <AuthProvider>
                <AppAuthProvider>
                  <GlobalStyles />
                  <ScrollReset />
                  <GoogleAnalytics />
                  {/* <CookiesNotification />
                <SettingsNotification /> */}
                  {renderRoutes(routes)}
                  {renderAppRoutes(appRoutes)}
                </AppAuthProvider>
              </AuthProvider>
            </Router>
          </SnackbarProvider>
        </MuiPickersUtilsProvider>
      </StylesProvider>
    </ThemeProvider>
  );
};

export default App;
